// extracted by css-extract-rspack-plugin
export default {"Box":"table-header-module__Box__Ko3Dj4v","Box_1":"table-header-module__Box_1__RhQj25H"};